import React, { useEffect, useState } from "react";
import "../../../styles/Auth/banner.css";
import { toast } from "react-toastify";
import { getData, uploadFile, postData, putData, deleteData } from "../../../webService/webservice";

const BannerPage = () => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const userId = sessionStorage.getItem("userId");
    const [linkUrl, setLinkUrl] = useState("");
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const [editingBanner, setEditingBanner] = useState(null);
    const [form, setForm] = useState({
        imageFile: null,
        previewUrl: null,
        order: "",
        redirectUrl: "",
    });


    // ADD BANNER POPUP STATES
    const [openPopup, setOpenPopup] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [order, setOrder] = useState(1);

    const triggerRefresh = () => setRefreshKey(prev => prev + 1);

    // ==============================
    // FETCH BANNERS
    // ==============================
    useEffect(() => {
        const fetchBanners = async () => {
            try {
                setLoading(true);
                const response = await getData("banner/list", {}, sessionToken);
                console.log(response);
                setBanners(response?.banner || []);
            } catch (error) {
                console.error("Banner Fetch Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBanners();
    }, [refreshKey]);

    const handleToggleStatus = async (bannerId, newStatus) => {
        try {
            const response = await putData(
                `banners/toggle-status/${bannerId}`,
                { isActive: newStatus },
                sessionToken
            );
            toast.success("Status updated");
            triggerRefresh();
        } catch (error) {
            toast.error("Failed to update status");
        }
    };

    // ==============================
    // ADD BANNER SUBMIT
    // ==============================
    const handleAddBanner = async () => {
        try {
            if (!imageFile) {
                toast.error("Please select banner image");
                return;
            }

            const form = new FormData();
            form.append("image", imageFile);     // file input
            form.append("order", order);
            form.append("linkUrl", linkUrl);
            form.append("isActive", true);

            const token = sessionStorage.getItem("sessionToken");

            const response = await postData("banner/add", form, token, true); 
            // 4th param "true" indicates multipart

            toast.success("Banner added successfully!");

            // Reset form
            setOpenPopup(false);
            setImageFile(null);
            setPreviewUrl(null);
            setOrder(1);
            triggerRefresh();

        } catch (error) {
            console.error("Add Banner Error:", error);
            toast.error("Failed to add banner");
        }
    };

    const openEditPopup = (banner) => {
        setForm({
            imageFile: null,
            previewUrl: banner.bannerImageObject?.uri
                ? `${process.env.REACT_APP_API_URL}${banner.bannerImageObject.uri}`
                : null,
            order: banner.order || "",
            redirectUrl: banner.redirectUrl || "",
        });

        setEditingBanner(banner);
        setOpenPopup(true);
    };

    const handleDelete = async (bannerId) => {
        try {
            const token = sessionStorage.getItem("Token");
            const res = await deleteData(`banners/${bannerId}`, token);
            toast.success("Banner deleted");
            triggerRefresh();
        } catch (error) {
            toast.error("Delete failed");
        }
    };



    return (
        <div className="banner-layout">
            <div className="banner-header">
                <h2>Banners</h2>

                <button className="add-btn-banner" onClick={() => setOpenPopup(true)}>
                    + Add Banner
                </button>
            </div>

            <div className="header-divider"></div>

            {/* Banner Cards */}
            <div className="banner-table-container">

                <table className="banner-table">
                    <thead>
                        <tr>
                            <th>Image</th>
                            <th>Order</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {banners.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="no-data">No banners found</td>
                            </tr>
                        ) : (
                            banners.map(b => (
                                <tr key={b._id}>
                                    {/* IMAGE */}
                                    <td>
                                        <img
                                            src={
                                                b.image
                                                    ? `${b.image}`
                                                    : "/placeholder.png"
                                            }
                                            alt="banner"
                                            className="banner-table-img"
                                        />
                                    </td>

                                    {/* ORDER */}
                                    <td>{b.order || "-"}</td>

                                    {/* STATUS TOGGLE */}
                                    <td>
                                        <label className="switch">
                                            <input
                                                type="checkbox"
                                                checked={b.isActive}
                                                onChange={(e) => handleToggleStatus(b._id, e.target.checked)}
                                            />
                                            <span className="slider"></span>
                                        </label>
                                    </td>

                                    {/* ACTION */}
                                    <td>
                                        <button
                                            className="btn-edit"
                                            onClick={() => openEditPopup(b)}
                                        >
                                            Edit
                                        </button>

                                        {/* <button
                                            className="btn-delete"
                                            onClick={() => handleDelete(b._id)}
                                        >
                                            Delete
                                        </button> */}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>

            </div>


            {/* POPUP FOR ADD BANNER */}
            {openPopup && (
            <div className="popup-overlay">
                <div className="popup-wrapper banner-popup">

                    <h2 className="popup-title">Add Banner</h2>

                    <div className="popup-body">

                        {/* IMAGE UPLOAD */}
                        <div className="form-group">
                            <label className="input-label">Banner Image</label>
                            <input
                                type="file"
                                accept="image/*"
                                className="popup-input"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    setImageFile(file);
                                    setPreviewUrl(URL.createObjectURL(file));
                                }}
                            />

                            {previewUrl && (
                                <div className="image-preview-container">
                                    <img src={previewUrl} alt="preview" className="image-preview" />
                                </div>
                            )}
                        </div>

                        {/* ORDER FIELD */}
                        <div className="form-group">
                            <label className="input-label">Order</label>
                            <input
                                type="number"
                                className="popup-input"
                                value={order}
                                onChange={(e) => setOrder(Number(e.target.value))}
                                min={1}
                            />
                        </div>

                        {/* NEW LINK FIELD */}
                        <div className="form-group">
                            <label className="input-label">Redirect URL</label>
                            <input
                                type="text"
                                className="popup-input"
                                placeholder="https://example.com/product/123"
                                value={linkUrl}
                                onChange={(e) => setLinkUrl(e.target.value)}
                            />
                        </div>

                    </div>

                    {/* BUTTONS */}
                    <div className="popup-buttons">
                        <button className="btn-primary" onClick={handleAddBanner}>
                            Save Banner
                        </button>
                        <button
                            className="btn-secondary"
                            onClick={() => {
                                setOpenPopup(false);
                                setPreviewUrl(null);
                                setImageFile(null);
                                setLinkUrl("");
                            }}
                        >
                            Cancel
                        </button>
                    </div>

                </div>
            </div>
        )}


        </div>
    );
};

export default BannerPage;
